import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    meta: {
      public: true
    },
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "auth" */ './pages/LoginPage.vue')
  },
  {
    meta: {
      public: true
    },
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import(/* webpackChunkName: "auth" */ './pages/ForgotPasswordPage.vue')
  },
  {
    meta: {
      public: true
    },
    path: '/reset-password/:token',
    name: 'reset-password',
    component: () => import(/* webpackChunkName: "auth" */ './pages/ResetPasswordPage.vue')
  },
  {
    meta: {
      public: true
    },
    path: '/activate/:token',
    name: 'activate-account',
    component: () => import(/* webpackChunkName: "auth" */ './pages/ActivateAccountPage.vue')
  }
]

export default routes
